import { gql } from '@apollo/client';

export const GENERATE_SALES_REPORT = gql`
  query salesReport($input: PaymentsReport!) {
    salesReport(input: $input) {
      labels
      extraLabels
      keys
      points
      data {
        values
      }
      summary {
        title
        value
      }
    }
  }
`;

export const EXPORT_SALES_REPORT = gql`
  query exportSalesReport($input: PaymentsReport!) {
    salesReport(input: $input) {
      url
    }
  }
`;

export const EXPORT_SALES = gql`
  query exportSales($input: SalesExportInput!) {
    exportSales(input: $input)
  }
`;
